import React from 'react';
import { Grid, Typography, Container, Box, Link } from '@mui/material';

const linksByCategory = [
  {
    title: 'Other Sources for GHG Information',
    links: [
      { name: 'NAEI', description: 'UK National Atmospheric Emissions Inventory', url: 'https://naei.beis.gov.uk/' },
      { name: 'DESNZ Verification Report', description: 'UK annual GHG Verification Reports prepared for DESNZ & DSIT', url: 'https://www.gov.uk/government/publications/uk-greenhouse-gas-emissions-monitoring-and-verification' },
      { name: 'CCC', description: 'UK Climate Change Committee', url: 'https://www.theccc.org.uk/' },
      { name: 'IPCC', description: 'Intergovernmental Panel on Climate Change', url: 'https://www.ipcc.ch/' },
    ],
  },
  {
    title: 'Measurement Networks',
    links: [
      { name: 'DECC', description: 'Deriving Emissions linked to Climate Change Network', url: 'https://www.bristol.ac.uk/chemistry/research/acrg/current/decc.html' },
      { name: 'ICOS', description: 'Integrated Carbon Observation System', url: 'https://www.icos-cp.eu/' },
      { name: 'GAW', description: 'Global Atmosphere Watch Programme', url: 'https://community.wmo.int/en/activity-areas/gaw/research-infrastructure/gaw-stations' },
      { name: 'AGAGE', description: 'Advanced Global Atmospheric Gases Experiment', url: 'https://agage.mit.edu/' },
    ],
  },
  {
    title: 'GEMMA Consortium',
    links: [
      { name: 'NPL', description: 'National Physical Laboratory', url: 'https://www.npl.co.uk/greenhouse-gas-emissions-measurement-modelling' },
      { name: 'MetOffice', description: 'National meteorological service for the UK', url: 'https://www.metoffice.gov.uk/weather/climate/met-office-hadley-centre/index' },
      { name: 'NCAS', description: 'National Centre for Atmospheric Science', url: 'https://ncas.ac.uk/' },
      { name: 'NCEO', description: 'National Centre for Earth Observation', url: 'https://www.nceo.ac.uk/' },
      { name: 'University of Bristol', description: 'University of Bristol Atmospheric Chemistry Department', url: 'https://www.bristol.ac.uk/chemistry/research/acrg/' },
      { name: 'UKCEH', description: 'UK Centre for Ecology & Hydrology', url: 'https://www.ceh.ac.uk/' },
    ],
  },
  {
    title: 'Related Projects',
    links: [
      { name: 'PARIS', description: 'Process Attribution of Regional Emissions. European research project.', url: 'https://horizoneurope-paris.eu/' },
      { name: 'STELLA', description: 'Stable Isotope Metrology to Enable Climate Action and Regulation', url: 'https://empir.npl.co.uk/stellarproject/' },
      { name: 'ISOMET', description: 'Stable Isotope Metrology follow-on from STELLA', url: 'https://www.euramet.org/research-innovation/search-research-projects/details/project/metrology-for-european-emissions-verification-on-methane-isotopes' },
    ],
  },
  {
    title: 'Software and Tools',
    links: [
      { name: 'OpenGHG', description: 'Open software platform for managing and distributing atmospheric data measurements', url: 'https://openghg.org/about/' },
    ],
  },
];

const RelatedLinks = () => (
  <Container sx={{ padding: '20px', maxWidth: '1200px', margin: '80px auto 0' }}>
    {linksByCategory.map((category) => (
      <div key={category.title}>
        <Typography sx={{ margin: '40px 0 20px', fontWeight: 'bold', fontSize: '1.5rem', textTransform: 'uppercase' }}>
          {category.title}
        </Typography>
        <Grid container spacing={3}>
          {category.links.map(({ name, description, url }) => (
            <Grid item xs={12} sm={6} md={4} key={name}>
              <Box
                sx={{
                  padding: '10px',
                  borderRadius: '8px',
                  transition: 'background 0.3s',
                  '&:hover': {
                    background: '#f5f5f5',
                  },
                }}
              >
                <Typography variant="h5" fontFamily={"Rockwell"}>
                  <Link href={url} target="_blank" rel="noopener noreferrer" underline="hover">
                    {name}
                  </Link>
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <Link href={url} target="_blank" rel="noopener noreferrer" underline="hover">
                    {description}
                  </Link>
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </div>
    ))}
  </Container>
);

export default RelatedLinks;
